import { createFileRoute } from '@tanstack/react-router';

import { ThemesGrid } from 'component/partial/grids/themes/ThemesGrid';

export const Route = createFileRoute('/n/_auth/sites/$siteId/_details/themes/discover')({
  component: ThemesDiscoverRoute,
});

function ThemesDiscoverRoute() {
  return <ThemesGrid />;
}
